import React, { useState } from "react";
import styled from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";
import CompanyDetailsCard from "./CompanyDetailsCard";
import {
  companyAddressCustomization,
  companyDetailsCustomization,
} from "@scenes/more/MoreScreen/utils";
import LayoutContainer from "@components/layout/LayoutContainer";
import { DefaultTheme } from "styled-components/native";
import { ScrollView } from "react-native";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTranslation } from "react-i18next";
import { VDBText } from "@components/atoms";
import ContactUsModal from "@components/molecules/ContactUs";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTheme } from "styled-components/native";

const CompanyDetailsScreen = () => {
  const userInfo = useUserInfo();
  const { t } = useTranslation();
  const theme = useTheme();
  const typography = useTypographyStore();
  const companyDetails = userInfo?.user?.display_user_company_details;
  const [showContactUsModal, setShowContactUsModal] = useState(false);
  return (
    <LayoutContainer>
      <ScrollView>
        <SplitContainer>
          <CompanyDetailsCard
            details={companyDetails}
            customization={companyDetailsCustomization(t)}
            title={t(
              "account.companyDetails.card.title.info.text",
              "Company Information"
            )}
            status={t(
              "account.companyDetails.card.title.status.text",
              "Approved"
            )}
          />
          <CompanyDetailsCard
            details={companyDetails}
            customization={companyAddressCustomization(t)}
            title={t(
              "account.companyDetails.card.title.address.text",
              "Company Address"
            )}
          />
          <ContactUsContainer>
            <ContactUsText>
              <VDBText type={typography["Minor-R"]} color={theme["core-06"]}>
                {t(
                  "account.companyDetails.card.screenFooter.text",
                  "Need to update your company details?"
                )}{" "}
                <VDBText
                  type={typography["Minor-M"]}
                  color={theme["link-static"]}
                  onPress={() => {
                    setShowContactUsModal(true);
                  }}
                >
                  {t("contactUs.title.text")}
                </VDBText>
              </VDBText>
            </ContactUsText>

            <ContactUsModal
              isOpen={showContactUsModal}
              onClose={() => setShowContactUsModal(false)}
              screenName="Company Details"
            />
          </ContactUsContainer>
        </SplitContainer>
      </ScrollView>
    </LayoutContainer>
  );
};

const SplitContainer = styled.View`
  gap: ${SpaceType.Big}px;
  flex-direction: column;
  padding: ${SpaceType.Double}px;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-01"]};
  border-radius: ${SpaceType.Basic}px;
  margin-horizontal: ${({ theme }) =>
    theme.isMobile ? SpaceType.Double : SpaceType.ExtraLarge}px;
  margin-top: ${({ theme }) =>
    theme.isMobile ? SpaceType.Double : SpaceType.ExtraLarge}px;
  ${({ theme }) => theme.isLargeScreen && `max-width: 50%;`}
  ${({ theme }) =>
    theme.isMobile
      ? `margin-bottom: ${SpaceType.Size_80}px;`
      : `margin-bottom: ${SpaceType.ExtraLarge}px;`}
`;

const ContactUsContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

const ContactUsText = styled.View``;

export default CompanyDetailsScreen;
